<template>
  <!-- 上方主体 人才计划-->
  <div class="container_top" id="topCont" @mouseover="barNum = 0">
    <!-- 轮播图 -->
    <div class="topTitCont">
      <img
        style="width: 100%; display: block"
        src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/3scattjuvcgztapf4kwh.png"
        alt=""
      />
      <div class="cont_topTil">
        <div>加入我们</div>
        <div class="cont_topButall">
          <div class="cont_topBut">社会招聘</div>
          <div class="cont_topBut">校园招聘</div>
        </div>
      </div>
    </div>

    <!-- 福利待遇 -->
    <div class="welfareTreat" ref="welfom">
      <div class="welf_compe_tit">福利待遇</div>
      <div class="welf_compe_fy">Welfare treatment</div>

      <div class="swiperCont">
        <swiper
          style="padding: 30px 0px"
          :options="swiperOption"
          ref="mySwiper"
        >
          <swiper-slide class="succ_swiper">
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/0nay84fxferj0skjgzxm.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide class="succ_swiper">
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/vpdrvvngqvhbbi4iblfv.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide class="succ_swiper">
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/sof070ml8r76ggks2msw.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide class="succ_swiper">
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/kjz5b0lsmf4evl9nit33.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide class="succ_swiper">
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/sof070ml8r76ggks2msw.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- 培养机制 -->
    <div class="mechanism" ref="mechanism">
      <div class="mech_compe_tit">培养机制</div>
      <div class="mech_compe_fy">mechanism</div>
      <div class="gateCont">
        <div
          class="gateBox"
          @mouseenter="getActive(0)"
          :class="{ gateActive: gateFlgAll.gateaFlg }"
        >
          <div
            class="gateImg"
            :class="gateFlgAll.gateaFlg ? 'gateNone' : 'gateBlock'"
          >
            <div
              class="img_bg"
              :style="{ 'background-image': 'url(' + imageUrl[0] + ')' }"
            >
              <div class="overlay">
                <div class="overlayTit">承诺</div>
                <div>COMMITMENT</div>
              </div>
            </div>
          </div>
          <div
            class="gateTxt"
            :class="gateFlgAll.gateaFlg ? 'gateBlock' : 'gateNone'"
          >
            <img
              src="https://oss.jingshucloud.com/gw-bucket/785235c6-bd07-4c38-9c58-576118fb4db8.png"
              alt=""
            />
            <div class="gateBotCont">
              <div class="gateBotCont_Tit">行业理解</div>
              <div>
                以丰富的行业经验,深刻的行业理解和产品化能力助力行业客户解决核心需求问题。
              </div>
            </div>
          </div>
        </div>
        <div
          class="gateBox"
          @mouseenter="getActive(1)"
          :class="{ gateActive: gateFlgAll.gatebFlg }"
        >
          <div
            class="gateImg"
            :class="gateFlgAll.gatebFlg ? 'gateNone' : 'gateBlock'"
          >
            <div
              class="img_bg"
              :style="{ 'background-image': 'url(' + imageUrl[2] + ')' }"
            >
              <div class="overlay">
                <div class="overlayTit">创新</div>
                <div>INNOVATION</div>
              </div>
            </div>
          </div>
          <div
            class="gateTxt"
            :class="gateFlgAll.gatebFlg ? 'gateBlock' : 'gateNone'"
          >
            <img
              src="https://oss.jingshucloud.com/gw-bucket/0a4586b4-cb4d-4548-a04d-1e8091b31008.png"
              alt=""
            />
            <div class="gateBotCont">
              <div class="gateBotCont_Tit">行业理解</div>
              <div>
                以丰富的行业经验,深刻的行业理解和产品化能力助力行业客户解决核心需求问题。
              </div>
            </div>
          </div>
        </div>
        <div
          class="gateBox"
          @mouseenter="getActive(2)"
          :class="{ gateActive: gateFlgAll.gatecFlg }"
        >
          <div
            class="gateImg"
            :class="gateFlgAll.gatecFlg ? 'gateNone' : 'gateBlock'"
          >
            <div
              class="img_bg"
              :style="{ 'background-image': 'url(' + imageUrl[1] + ')' }"
            >
              <div class="overlay">
                <div class="overlayTit">承诺</div>
                <div>COMMITMENT</div>
              </div>
            </div>
          </div>
          <div
            class="gateTxt"
            :class="gateFlgAll.gatecFlg ? 'gateBlock' : 'gateNone'"
          >
            <img
              src="https://oss.jingshucloud.com/gw-bucket/d6e30e7d-68a3-4cd3-8cfb-b20e1a9c914a.png"
              alt=""
            />
            <div class="gateBotCont">
              <div class="gateBotCont_Tit">行业理解</div>
              <div>
                以丰富的行业经验,深刻的行业理解和产品化能力助力行业客户解决核心需求问题。
              </div>
            </div>
          </div>
        </div>
        <div
          class="gateBox"
          @mouseenter="getActive(3)"
          :class="{ gateActive: gateFlgAll.gatedFlg }"
        >
          <div
            class="gateImg"
            :class="gateFlgAll.gatedFlg ? 'gateNone' : 'gateBlock'"
          >
            <div
              class="img_bg"
              :style="{ 'background-image': 'url(' + imageUrl[3] + ')' }"
            >
              <div class="overlay">
                <div class="overlayTit">自主研发</div>
                <div>AUTONOMY</div>
              </div>
            </div>
          </div>
          <div
            class="gateTxt"
            :class="gateFlgAll.gatedFlg ? 'gateBlock' : 'gateNone'"
          >
            <img
              src="https://oss.jingshucloud.com/gw-bucket/62b7838c-1946-4c2e-a7a7-eb40a9d46541.png"
              alt=""
            />
            <div class="gateBotCont">
              <div class="gateBotCont_Tit">行业理解</div>
              <div>
                以丰富的行业经验,深刻的行业理解和产品化能力助力行业客户解决核心需求问题。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  props: { switchNum: String },
  components: {},
  data() {
    return {
      swiperOption: {
        grabCursor: true,

        // 滑动方向
        // direction: 'horizontal',

        // 衔接滑动
        loop: true,
        // 自动滑动
        // autoplay: {
        //   delay: 5000,
        //   // 如果设置为true，当切换到最后一个slide时停止自动切换。
        //   stopOnLastSlide: false,
        //   // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
        //   disableOnInteraction: false,
        // },

        // 设置slider容器能够同时显示的slides数量
        slidesPerView: 3,
        //slider容器相互之间距离
        spaceBetween: 40,

        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        centeredSlides: true,

        // 设置为true则点击slide会过渡到这个slide。
        // slideToClickedSlide: true,

        effect: "coverflow",
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          paginationClickable: true,
        },
      },
      gateFlgAll: {
        gateaFlg: true,
        gatebFlg: false,
        gatecFlg: false,
        gatedFlg: false,
      },
      imageUrl: [
        "https://oss.jingshucloud.com/gw-bucket/785235c6-bd07-4c38-9c58-576118fb4db8.png",
        "https://oss.jingshucloud.com/gw-bucket/d6e30e7d-68a3-4cd3-8cfb-b20e1a9c914a.png",
        "https://oss.jingshucloud.com/gw-bucket/0a4586b4-cb4d-4548-a04d-1e8091b31008.png",
        "https://oss.jingshucloud.com/gw-bucket/62b7838c-1946-4c2e-a7a7-eb40a9d46541.png",
      ],
    };
  },
  computed: {},
  watch: {
    switchNum(curVal, oldVal) {
      // console.log("测试switchNum",curVal, oldVal);

      if (curVal == 3) {
        document
          .getElementById("topCont")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {
    console.log(this.switchNum);
  },
  created() {
    if (this.switchNum == 3) {
      document.getElementById("topCont").scrollIntoView({ behavior: "smooth" });
    }
  },
  methods: {
    handleScroll() {
      if (this.$refs.welfom && this.$refs.welfom.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.welfom.offsetTop,
        //   this.switchNum
        // );
        this.$emit("switchflg", "0");
      }
    },
    getActive(row) {
      if (row == 0) {
        this.gateFlgAll.gateaFlg = true;
        this.gateFlgAll.gatebFlg = false;
        this.gateFlgAll.gatecFlg = false;
        this.gateFlgAll.gatedFlg = false;
      }
      if (row == 1) {
        this.gateFlgAll.gatebFlg = true;
        this.gateFlgAll.gateaFlg = false;
        this.gateFlgAll.gatecFlg = false;
        this.gateFlgAll.gatedFlg = false;
      }
      if (row == 2) {
        this.gateFlgAll.gatecFlg = true;
        this.gateFlgAll.gatebFlg = false;
        this.gateFlgAll.gateaFlg = false;
        this.gateFlgAll.gatedFlg = false;
      }
      if (row == 3) {
        this.gateFlgAll.gatedFlg = true;
        this.gateFlgAll.gatebFlg = false;
        this.gateFlgAll.gatecFlg = false;
        this.gateFlgAll.gateaFlg = false;
      }
    },
  },
};
</script>
    
<style lang="less" scoped>
.container_top {
  width: 100%;
  .cont_topTil {
    // width: 100%;
    // max-width: 1200px;
    // margin: 0px auto;
    position: absolute;
    bottom: 50%;
    left: 37%;
    font-size: 46px;
    font-weight: 600;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .cont_topButall {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }
  .cont_topBut {
    font-size: 25px;
    font-weight: 400;
    border: 2px solid white;
    padding: 10px 48px;
    margin: 0 10px;
  }
}

// 福利待遇
.welfareTreat {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // padding: 80px 105px;
  padding: 80px 58px;
  .welf_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
    width: 130px;
  }
  .welf_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 60px;
    width: 100%;
  }
  .welf_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  .welfCont {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 80px 0;
  }
  // 福利待遇轮播
  .swiperCont {
    margin: 5% 0;
    // width: 100%;
    width: 1495px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1200px;
  }
  .succ_swiper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .succ_swiper_Cont {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .swiper-slide {
    // margin-right: 0px !important;
    // margin-right: 40px !important;
    // margin-left: 40px;
    // width: 400px !important;
  }
  .swiper_Cont_left {
    padding: 55px 0 25px 11%;
  }
  .swiper_top_img {
    width: 9%;
    margin-bottom: 20px;
  }
  .swiper_time {
    color: #7bb7c6;
    font-size: 28px;
  }
  .swiper_Tit {
    width: 50%;
    font-size: 22px;
    margin: 30px 0;
  }
  .swiperBot_txt {
    line-height: 25px;
    width: 50%;
  }
  .swiperBotImg {
    width: 100%;
  }
}
.mechanism {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  //   padding: 80px 0;
  position: relative;
  .mech_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
    width: 130px;
  }
  .mech_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 60px;
    width: 100%;
  }
  .mech_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  .gateCont {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 80px 0;
    z-index: 33;
    width: 1430px;
  }
  .img_bg {
    width: 550px;
    height: 485px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 40% 50%;
    position: relative;
  }
  .gateBox {
    width: 293px;
    // margin-left: 0;
    height: 485px;
    transition: all ease-out 0.4s;
  }
  .gateActive {
    width: 550px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // height: 550px;
    // margin-left: 1px;
  }
  .gateBlock {
    display: flex;
  }
  .gateNone {
    display: none;
  }

  .gateBotCont {
    // background: linear-gradient(360deg, #003365 0%, #048799 100%);
    background: #04758e;
    padding: 35px 25px;
    color: #fff;
    height: 90px;
    // width: 550px;
  }
  .gateBotCont_Tit {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .gateTxt {
    justify-content: center;
    flex-direction: column;
  }
  .gateTxt img {
    height: 325px;
    // width: 550px;
  }
  .overlay {
    position: absolute;
    background-color: rgba(31, 31, 31, 0.34);
    width: 100%;
    height: 100%;
    display: none;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
  }
  .overlayTit {
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
    